<template>
<div class="chapter">
<div class="inner_page">
<h2 class="fm-title"><a id="page_3"></a><span class="bold">Contents</span></h2>
<h2 class="toc-c"><a href="#/xhtml/03_Introduction#int">Introduction</a></h2>
<h2 class="toc-c"><a href="#/xhtml/05_Chapter_1#ch1">Chapter 1 – The First Air War</a></h2>
<h2 class="toc-c"><span href="#/xhtml/06_Chapter_2#ch2" title="Link target outside of Sample">Chapter 2 – Things Get Serious</span></h2>
<h2 class="toc-c"><span href="#/xhtml/07_Chapter_3#ch3" title="Link target outside of Sample">Chapter 3 – The Fokker’s Day</span></h2>
<h2 class="toc-c"><span href="#/xhtml/08_Chapter_4#ch4" title="Link target outside of Sample">Chapter 4 – Fokker Aces Supreme</span></h2>
<h2 class="toc-c"><span href="#/xhtml/09_Chapter_5#ch5" title="Link target outside of Sample">Chapter 5 – Knights of the Air</span></h2>
<h2 class="toc-c"><span href="#/xhtml/10_Chapter_6#ch6" title="Link target outside of Sample">Chapter 6 – Nieuport Scouts</span></h2>
<h2 class="toc-c"><span href="#/xhtml/11_Chapter_7#ch7" title="Link target outside of Sample">Chapter 7 – Autumn Chill</span></h2>
<h2 class="toc-c"><span href="#/xhtml/12_Chapter_8#ch8" title="Link target outside of Sample">Chapter 8 – The End of 1916</span><a id="page_4"></a></h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Toc.vue?47ff95e0